import React from 'react'
import { Typography } from '@material-ui/core'
import { doc, getDoc } from 'firebase/firestore'
import parkingNotificaionsStyles from './parkingNotificationsStyles'
import { firestore } from '../../../../../../../utils/firebase'

const handleMessageLogic = (messages, userProfile) => {
  const today = Date.now()
  const filteredMessages = messages.filter((message) => {
    const isWithinDateRange =
      today >= Number(message.startDate) && today <= Number(message.endDate)
    const hasMatchingRole =
      userProfile?.roles?.includes(message.audience) ||
      message.audience === 'all'
    return isWithinDateRange && hasMatchingRole && message.active
  })

  return filteredMessages
}

function ParkingNotifications({ userProfile }) {
  const classes = parkingNotificaionsStyles()
  const [parkingNotifications, updateParkingNotifications] = React.useState([])
  const [parkingNotificationsIndex, updateParkingNotificationsIndex] =
    React.useState(0)
  const [parkingNotificationsIndexMax, updateParkingNotificationsIndexMax] =
    React.useState(0)
  // Load notifications once on mount
  React.useEffect(() => {
    async function loadParkingNotifications() {
      const docRef = doc(firestore, 'MyMaps', 'parkingNotifications')
      const docSnapshot = await getDoc(docRef)
      if (docSnapshot.exists()) {
        const filteredMessages = handleMessageLogic(
          docSnapshot.data().messages,
          userProfile,
        )
        updateParkingNotifications(filteredMessages)
        updateParkingNotificationsIndexMax(filteredMessages.length)
        return filteredMessages
      }
      throw new Error('No parking notifications avialable.')
    }
    loadParkingNotifications()
  }, [])

  // Increment index every 5 seconds until max is reached
  // eslint-disable-next-line
  React.useEffect(() => {
    if (parkingNotificationsIndex < parkingNotificationsIndexMax) {
      const timer = setTimeout(() => {
        updateParkingNotificationsIndex(parkingNotificationsIndex + 1)
      }, 5000)
      return () => clearTimeout(timer)
    }
  }, [parkingNotificationsIndex, parkingNotificationsIndexMax])
  if (!parkingNotifications[parkingNotificationsIndex]) return null
  return (
    <>
      <div className={classes.parkingNotificationOverlay}>
        <div className={classes.parkingNotificationContainer}>
          <Typography variant="subtitle1" style={{ marginBottom: '5px' }}>
            {parkingNotifications[parkingNotificationsIndex].message}
          </Typography>
          {parkingNotifications[parkingNotificationsIndex].link ? (
            <div className={classes.parkingLinkContainer}>
              <Typography
                variant="subtitle"
                component="a"
                className={classes.parkingLink}
              >
                {parkingNotifications[parkingNotificationsIndex].link}
              </Typography>
            </div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export default ParkingNotifications
